module.exports = __webpack_public_path__ + "media/images/beer-5f94e047aa4c952b00b7fcd8d3d69851.png";